import { render, staticRenderFns } from "./PhoneInfoAgreementForm.vue?vue&type=template&id=52353fa6&scoped=true&"
import script from "./PhoneInfoAgreementForm.vue?vue&type=script&lang=js&"
export * from "./PhoneInfoAgreementForm.vue?vue&type=script&lang=js&"
import style0 from "./PhoneInfoAgreementForm.vue?vue&type=style&index=0&id=52353fa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52353fa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VFlex})
